export enum AccountDataEvent {
  PushRules = 'm.push_rules',
  Direct = 'm.direct',
  IgnoredUserList = 'm.ignored_user_list',
  FullyRead = 'm.fully_read',
  MarkedUnread = 'm.marked_unread',

  CinnySpaces = 'in.cinny.spaces',

  ElementRecentEmoji = 'io.element.recent_emoji',

  PoniesUserEmotes = 'im.ponies.user_emotes',
  PoniesEmoteRooms = 'im.ponies.emote_rooms',

  SecretStorageDefaultKey = 'm.secret_storage.default_key',

  ElevoLinks = 'vip.elevo.links',
  StarredThreads = 'vip.elevo.starred_threads',

  CrossSigningMaster = 'm.cross_signing.master',
  CrossSigningSelf = 'm.cross_signing.self',
  CrossSigningUser = 'm.cross_signing.user',
  MegolmBackupV1 = 'm.megolm_backup.v1',
}

export type MDirectContent = Record<string, string[]>;

export type MFullyReadContent = {
  event_id: string;
};

export type MMarkedUnreadContent = {
  unread: boolean;
};

export type SecretStorageDefaultKeyContent = {
  key: string;
};

export type SecretStoragePassphraseContent = {
  algorithm: string;
  salt: string;
  iterations: number;
  bits?: number;
};

export type SecretStorageKeyContent = {
  name?: string;
  algorithm: string;
  iv?: string;
  mac?: string;
  passphrase?: SecretStoragePassphraseContent;
};

export type SecretContent = {
  iv: string;
  ciphertext: string;
  mac: string;
};

export type SecretAccountData = {
  encrypted: Record<string, SecretContent>;
};

export type ConnectorsContent = {
  javis?: {
    accessToken?: string;
  };
};

export type WorkspaceOAuthConnection = {
  accessToken: string;
  refreshToken?: string;
  expiresIn: number;
  scope: string;
  connectedAt: string;
  serverUrl: string;
};

export type LinksContent = {
  workspaces?: WorkspaceOAuthConnection;
};

export type StarredThreadEntry = {
  roomId: string;
  threadId: string;
  title?: string;
  starredAt: number;
};

export type StarredThreadsContent = {
  threads?: StarredThreadEntry[];
};
